import { useEffect, useRef } from 'react'

// Keep periodic work out of background tabs, then catch up once on return.
export default function useVisibleRefresh(refresh, interval) {
    const refreshRef = useRef(refresh)

    useEffect(() => {
        refreshRef.current = refresh
    }, [refresh])

    useEffect(() => {
        if (!interval) return

        let timer
        let wasHidden = document.hidden
        const stop = () => window.clearInterval(timer)
        const start = () => {
            stop()
            if (!document.hidden) {
                timer = window.setInterval(() => {
                    if (!document.hidden) refreshRef.current()
                }, interval)
            }
        }
        const onVisibilityChange = () => {
            if (document.hidden) {
                stop()
            } else if (wasHidden) {
                refreshRef.current()
                start()
            }
            wasHidden = document.hidden
        }

        start()
        document.addEventListener('visibilitychange', onVisibilityChange)
        return () => {
            stop()
            document.removeEventListener('visibilitychange', onVisibilityChange)
        }
    }, [interval])
}
